module.exports = __webpack_public_path__ + "img/2.6e5949b5.png";